import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://d69e9c1c8b9df46f898c613dff073a66@o4511176225718272.ingest.us.sentry.io/4511176227160064',
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});

function ErrorFallback() {
  // Dev mode: Sentry transmission is disabled, so the "we've been notified"
  // copy would be misleading. See DEF-026.
  const isProd = process.env.NODE_ENV === 'production';
  const message = isProd
    ? "We've been notified and are looking into it."
    : 'Dev mode — error not sent to Sentry. Check the browser console.';

  return (
    <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'Montserrat, sans-serif' }}>
      <div style={{
        fontSize: '14px',
        fontWeight: 600,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: '#7c3aed',
        marginBottom: '32px',
        fontFamily: 'Montserrat, sans-serif',
      }}>
        Divine Frameworks
      </div>
      <h1 style={{ fontSize: '24px', marginBottom: '16px' }}>Something went wrong</h1>
      <p style={{ color: '#6b7280', marginBottom: '24px' }}>
        {message}
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 24px',
            backgroundColor: '#7c3aed',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: 'pointer',
            fontFamily: 'Montserrat, sans-serif',
          }}
        >
          Reload page
        </button>
        <button
          onClick={() => { window.location.href = '/dashboard/practitioner'; }}
          style={{
            padding: '12px 24px',
            backgroundColor: 'transparent',
            color: '#7c3aed',
            border: '2px solid #7c3aed',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: 'pointer',
            fontFamily: 'Montserrat, sans-serif',
          }}
        >
          Go to dashboard
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <App />
  </Sentry.ErrorBoundary>
);

reportWebVitals();
